/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import toast from "react-hot-toast";

import { VApplication } from "../../../application";
import { pretty } from "@vlinder-web/utils-react";
import { AppNavigatorService } from "../../appNavigatorService";
import { UPLOAD_FILE, Update_Band } from "../graphql";
import { StorageModule } from "@vlinder-web/storage-module-react";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.AppNavigatorService"
  ) as AppNavigatorService;
};

export interface IUpdateBrandsMethods extends IPluginMethodMap {
  getUpdateBrands(args: any): Promise<any>;
}

export class UpdateBrandsService implements IAgentPlugin {
  readonly methods: IUpdateBrandsMethods;

  constructor() {
    this.methods = {
      getUpdateBrands: this.getUpdateBrands.bind(this),
    };
  }

  async getUpdateBrands(args: any) {
    console.log(`service args`, pretty(args));
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const storageSrv = StorageModule.getInstance();
        const localStorage = storageSrv?.get("currencyExchangeLocal", "local");
        let band;
        if (is.existy(localStorage?.band)) {
          band = localStorage?.band
        }
        const _data = args;
        let _res;
        console.log(_data?.event?.brandLogo)
        // let base64: any, imageType: any;
        // if (_data?.event?.brandLogo) {
        //   console.log(_data?.event?.brandLogo)
        //   let logo = _data?.event?.brandLogo;
        //   let name = logo.split(",");
        //   let image = name[0];
        //   imageType = image.split(":")[1].split(";")[0].split("/")[1];
        //   base64 = name[1];
        // }
        // console.log(imageType, base64)
        // if (base64 && imageType) {
        //   _res = await client.mutate({
        //     mutation: UPLOAD_FILE,
        //     variables: {
        //       name: imageType,
        //       data: base64,
        //     },
        //     fetchPolicy: "no-cache",
        //   });
        // }
        const res = await client.mutate({
          mutation: Update_Band,
          variables: {
            filter: {
              bandName: band
            },
            update: {
              bandLogo: args?.event?.brandLogo?.base64 ? args?.event?.brandLogo?.base64 : args?.event?.brandLogo,
              primaryTheme: args?.event?.primaryColor,
              secondaryTheme: args?.event?.secondaryColor
            }
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          await this.fetchTheme(args);
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private fetchTheme = async (args?: any) => {
    await getSrv()?.getBrandProfile();
  };
}
